import { docsConsoleApiIntro, docsConsoleApiTitle } from 'Clepit/translations';
import type { SupportedLanguage } from '@bomdisoft/translations';
import type { EditorData } from '@clepit/core';

/** Derived from `app/[lang]/settings/api`. */
export const buildConsoleApi = (language: SupportedLanguage): EditorData => ({
  blocks: [
    { data: { html: docsConsoleApiTitle[language], level: 'h1' as const }, type: 'header' },
    { data: { html: docsConsoleApiIntro[language] }, type: 'paragraph' },

    { data: { alt: 'The API keys settings screen', caption: 'API keys: the key list and the create flow.', url: '/images/docs/console/api/screen-light.png' }, type: 'image' },
    { data: { alt: 'The API keys settings screen, dark theme', caption: 'API keys: the key list and the create flow.', url: '/images/docs/console/api/screen-dark.png' }, type: 'image' },

    { data: { html: 'Creating a key', level: 'h2' as const }, type: 'header' },
    {
      data: {
        html: 'Name the key and choose whether it may write; a key without write access is read-only. The secret is shown exactly once, with a copy button and a done step, and after that only the key metadata remains visible, so a leaked screen never shows a live secret.',
      },
      type: 'paragraph',
    },

    { data: { html: 'Where the references are', level: 'h2' as const }, type: 'header' },
    {
      data: {
        html: 'The screen links to the OpenAPI document and the MCP endpoint for this workspace. The protocols behind them are documented under the server section: <a href="./../server/rest">REST</a>, <a href="./../server/graphql">GraphQL</a>, <a href="./../server/realtime">realtime</a>, and <a href="./../server/mcp">MCP</a>.',
      },
      type: 'paragraph',
    },
  ],
  time: 1_745_000_000_000,
  version: '1.0.0',
});
